import React from 'react';
import { FileTextIcon, GiftIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="overflow-hidden rounded-2xl border border-berry-600/15 bg-white shadow-lg shadow-berry-800/10" data-id="element-17" data-mp="2o5v6a6qvvyl2">
      <div className="flex items-center gap-3 border-b border-berry-600/10 bg-blush-50 px-4 py-3 md:px-5" data-id="element-18" data-mp="2x58ktdtv7dcn">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-berry-600 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-white md:text-[11px]" data-id="element-19" data-mp="20ezj5mxdhrk5">
          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="29fe94zla7utz" />
          Free Bonus {bonus.number}
        </span>
        <h3 className="text-sm font-black uppercase leading-tight text-plum-950 md:text-base" data-id="element-21" data-mp="2e6e7m9a1ukyl">{bonus.name}</h3>
      </div>
      <div className="px-4 py-4 md:px-5" data-id="element-22" data-mp="1hmwy7zdp7p43">
        <p className="text-xs font-black uppercase tracking-wider text-berry-700" data-id="element-23" data-mp="1hm5fhp579lv8">{bonus.subtitle}</p>
        <p className="mt-2 text-sm font-semibold leading-relaxed text-plum-950" data-id="element-24" data-mp="1ln76jioyqrm4">{bonus.summary}</p>
        <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-25" data-mp="1x3xtx5ij8vxi">{bonus.details}</p>
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-wider text-muted" data-id="element-26" data-mp="1s3tl81nv95hu">Includes:</p>
        <ul className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-27" data-mp="1na8lo56mk3gj">
          {bonus.items.map(item => <li key={item} className="rounded-md bg-blush-100 px-2 py-1 text-xs font-semibold text-plum-900" data-id="element-28" data-mp="1ib4fzoiwsnuy">
              {item}
            </li>)}
        </ul>
        <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="19br4yrf4zr84">{bonus.closing}</p>
        <p className="mt-2 text-sm font-bold text-plum-950" data-id="element-30" data-mp="14co0b832jn0o">{bonus.tagline}</p>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-berry-600/10 pt-3" data-id="element-31" data-mp="zemi0pdgvrq9">
          <p className="flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-berry-700" data-id="element-32" data-mp="2yrql4sh6agx9">
            <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-33" data-mp="2ttfaifj202dz" />
            {bonus.pages}
          </p>
          <p className="flex items-center gap-2" data-id="element-34" data-mp="s2g6q46ge633">
            <span className="text-xs font-semibold text-muted" data-id="element-35" data-mp="wty7ar4ke4nj">Listed value:</span>
            <span className="text-sm font-black text-muted line-through decoration-berry-600 decoration-2" data-id="element-36" data-mp="wvrf49qwyux4">
              ${bonus.value} USD
            </span>
            <span className="rounded-md bg-berry-600 px-3 py-1 text-xs font-black uppercase text-white" data-id="element-37" data-mp="n4wsh49r9tb5">Free</span>
          </p>
        </div>
      </div>
    </article>;
}